import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=31ad6f9f&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=31ad6f9f&prod&scoped=true&lang=scss"
import style1 from "./contact.vue?vue&type=style&index=1&id=31ad6f9f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad6f9f",
  null
  
)

export default component.exports